import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-need-verify",
  "use": "icon-need-verify-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-need-verify\"><g><circle cx=\"6\" cy=\"6\" r=\"6\" /><circle fill=\"white\" cx=\"6\" cy=\"6\" r=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol